<template>
    <div id="challenge-question-page" class="content-wrap">
        <div class="content-top-wrap count-down">
            <i class="icon icon-clock"/>
            <CountDown
                ref="countdown"
                :time="30 * 1000"
                format="ss"
                @finish="handleCountDownFinish"
            ></CountDown>
        </div>
        <div class="content-top-wrap level-wrap">
            <div :class="['level-1', index >= 0 && 'active']">初级</div>
            <div :class="['level-2', index >= 5 && 'active']">中级</div>
            <div :class="['level-3', index >= 10 && 'active']">高级</div>
        </div>
        <div class="scroll-content middle" ref="content">
            <Question
                :question="questions[index]"
                :val.sync="answers[index]"
            >
                <span v-if="questions.length" slot="queIndex">
                    {{index + 1}}/{{questions.length}}
                </span>
            </Question>
        </div>
        <div class="content-bottom-wrap button-wrap">
            <Button
                class="btn btn-primary"
                @click="handleStop">结束并计分</Button>
            <Button 
                class="btn btn-primary"
                :disabled="!canNext"
                @click="handleNext">{{questions.length - 1 > index ? '继续下一题' : '提交'}}</Button>
        </div>
    </div>
</template>

<script>
import { CountDown, Button } from 'vant'
import Question from '@/components/Question'
import { quizApi } from '@/apis'
import { throttle } from '@/utils/func'

export default {
    components: {
        Question,
        CountDown,
        Button
    },
    props: ['result'],
    data () {
        return {
            questions: [],
            answers: [],
            index: 0,
            right_num: 0
        }
    },
    watch: {
        index () {
            this.$refs.countdown.reset()
            this.$refs.countdown.start()
            this.$refs.content.scrollTop = 0
        },
    },
    computed: {
        question () {
            return this.questions[this.index]
        },
        answer () {
            return this.answers[this.index]
        },
        canNext: function () {
            return this.answer && typeof this.answer.seq_id === 'number'
        }
    },
    methods: {
        async getQuizs () {
            const { body } = await quizApi.quizsGet({
                params: {
                    limit: 15,
                    category: 'sun',
                    quiz_type: 'new_agri_challenge'
                }
            })
            this.questions = body
            this.answers = new Array(body.length).fill({})
        },
        async handleStop () {
            this.updatePageResult('end')
        },
        handleNext: throttle(async function () {
            this.$refs.countdown.pause()

            // 请求答案 await
            const { body: { is_right: isRight }} = await quizApi.quizResultCheckPost({
                body: {
                    quiz_id: this.question.quiz_id,
                    answer_seq_num: this.answer.seq_id
                }
            })

            // 答案正确
            if (isRight) {
                this.right_num++
                if (this.index < this.questions.length - 1) {
                    // 不是最后一题，跳转至下一题
                    return this.index++
                }
                else {
                    this.updatePageResult()
                }
            } else {
                this.updatePageResult('fail')
            }
        }, 400),
        async handleCountDownFinish () {
            this.updatePageResult('fail')
        },
        async getResults (type) {
            const answers = this.questions.map((item, index) => {
                return {
                    quiz_id: item.quiz_id,
                    score: item.score,
                    answer_seq_num: this.answers[index] && this.answers[index].seq_id || 0,
                }
            })
            // 失败或结束不记录当前回答
            answers[this.index].answer_seq_num = type === 'success' ? answers[this.index].answer_seq_num : 0

            const { body } = await quizApi.quizResultsPost({
                body: {
                    is_add_score: type !== 'fail',
                    quiz_type: 'new_agri_challenge',
                    user_quizs: answers
                }
            })
            return body
        },
        updatePageResult: throttle(async function (type = 'success') {
            const result = await this.getResults(type)
            this.$emit('update:result', {
                ...result,
                quizId: this.question.quiz_id,
                type
            })
        })
    },
    mounted () {
        this.getQuizs()
    }
}
</script>

<style lang="less" scoped>
@height: 5rem;
@width: 6rem;
@normal-color: #B5B5B5;
@active-color: #FFCC2B;

#challenge-question-page {
    .level-wrap {
        display: inline-flex;
        flex-direction: row;
        background-color: transparent;
        width: calc(76vw + 1.6rem);
        margin: 4rem auto 1.5rem;
        [class^=level] {
            margin-right: @width / 2 + 0.7rem;
            background-color: @normal-color;
            position: relative;
            height: @height;
            line-height: @height;
            color: #fff;
            font-size: 14px;
            flex: 1;
            text-align: center;
            font-weight: bolder;
            &.active {
                color: #000;
                background-color: @active-color;
                &:nth-child(2), &:nth-child(3) {
                    &::before {
                        border-color: @active-color;
                        border-left-color: transparent;
                        border-right-color: transparent;
                    }
                }
                &::after {
                    border-left-color: @active-color;
                }
            }
            &:first-child {
                padding-left: 1.5rem;
            }
            &:nth-child(2), &:nth-child(3) {
                &::before {
                    content: ' ';
                    display: block;
                    width: 0;
                    height: 0;
                    border-width: @width / 2;
                    border-top-width: @height / 2;
                    border-bottom-width: @height / 2;
                    border-style: solid;
                    border-color: @normal-color;
                    border-left-color: transparent;
                    border-right-color: transparent;
                    position: absolute;
                    left: -@width / 2;
                    top: 0;
                }
            }
            &::after {
                content: ' ';
                display: block;
                width: 0;
                height: 0;
                border-width: @width / 2;
                border-top-width: @height / 2;
                border-bottom-width: @height / 2;
                border-style: solid;
                border-color: transparent;
                border-left-color: @normal-color;
                position: absolute;
                left: 100%;
                top: 0;
            }
        }
    }
    .content-top-wrap {
    }

    .count-down {
        display: flex;
        justify-content: flex-end;
        margin: 1.7rem 1.9rem;
        position: absolute;
        top: 0;
        right: 0;
        /deep/.van-count-down, .icon {
            display: inline-block;
            color: #fff;
            font-size: 1.3rem;
            font-weight: bold;
            line-height: 2.1rem;
        }
        /deep/.van-count-down {
            width: 2rem;
            text-align: center;
        }
        .icon {
            margin-right: .5rem;
            font-size: 2.1rem;
        }
    }

    .btn {
        margin-top: 6vh;
        &:first-child{
            margin-right: 14vw;
        }
    }
}
</style>